import { z } from 'zod'

const TaxonomyTermSchema = z.object({
  id: z.number(),
  count: z.number(),
  description: z.string(),
  link: z.string(),
  name: z.string(),
  slug: z.string(),
  taxonomy: z.string(),
  parent: z.number().nullish(),
})

export const TaxonomyRestSchema = z.array(TaxonomyTermSchema)

export type WpRestOrdering = {
  order?: 'asc' | 'desc'
  orderby?: 'title' | 'date'
}
